import { Controller } from "@hotwired/stimulus"

// A button anywhere on the page that opens a picker panel by id.
export default class extends Controller {
  static values = { id: String }

  open(event) {
    event.preventDefault()
    window.dispatchEvent(new CustomEvent("picker:open", { detail: { id: this.idValue } }))
  }
}
